import React, { Component } from 'react';

class Login extends Component {
  render() {
    return <div />;
  }
}

export default Login;
